import React from 'react';
import CHECK_MARK from '@arrive/ui-icons/svg/ic_circle_check_alt.svg'
import ERROR_OUTLINE from '@arrive/ui-icons/svg/ic_error_outline.svg'

import { useCommittedCapacityContext } from '../../context/committed-capacity.context';
import CommittedCapacityLandingPage from '../LandingPage/LandingPage';

import BookedTenderStyles from '../BookedTender/BookedTender.scss'

interface ErrorBookingProps {
  subtitle?: string;
}

export function ErrorBooking({ subtitle = 'Something went wrong...' }: ErrorBookingProps) {
  const { tenderDetails } = useCommittedCapacityContext();

  return (
    <CommittedCapacityLandingPage
      actionLinkTo={`/Load/${tenderDetails.loadNumber}`}
      className={BookedTenderStyles.bookedTenderContainer}
      actionText="Looking for loads? Search our Load Board"
      content={
        <>
          <span>Contact your rep if you have any questions or changes.</span>
          <br />
          <span>Thank you for you for participating in the Committed Capacity Program.</span>
        </>
      }
      icon={ERROR_OUTLINE}
      subTitle={subtitle}
    />
  );
}

export function SuccessFullyBooking() {
  const { tenderDetails } = useCommittedCapacityContext();

  return (
    <CommittedCapacityLandingPage
      actionLinkTo={`/Load/${tenderDetails.loadNumber}`}
      className={BookedTenderStyles.bookedTenderContainer}
      actionText="See load details"
      content={
        <>
          <span>Thank you for participating in the Committed Capacity Program</span>
          <br />
          <span>Contact your rep if you have any questions or changes</span>
        </>
      }
      icon={CHECK_MARK}
      subTitle={`Load Tender #${tenderDetails.loadNumber} successfully booked.`}
    />
  );
}
